import { useState } from 'react'
import { appointmentList, logOutApi, clients, teams } from '../../../Context/api';
import axios from 'axios';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { useEffect } from 'react';
import moment from 'moment'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const UseAppointment = () => {
    const [appointmentFilterData, setAppointmentFilterData] = useState([])
    const [clientList, setClientList] = useState([])
    const [teamList, setTeamList] = useState([])
    const [filter, setFilter] = useState({
        staff: '',
        client: '',
        status: '',
        appointmentsNO: '',
        statDate: '',
        endDate: '',
    })
    const [page, setPage] = useState(1)
    const [count, setCount] = useState('')
    const [spinner, setSpinner] = useState(false)
    const PER_PAGE = 10
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()

    useEffect(() => {
        appointmentLists()
        setSpinner(true)
        client()
        team()
    }, [page])

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const client = () => {
        axios.post(clients(), {}).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setClientList(resp.data.data)
            }
            else {
                setClientList([])
            }

        })
    }
    const team = () => {
        axios.post(teams(), {}).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setTeamList(resp.data.data)
            }
            else {
                setTeamList([])
            }
        })
    }
    const appointmentLists = () => {
        const data = {
            userId: adminData.userId,
            staffs: filter.staff,
            clients: filter.client,
            status: filter.status,
            appointment_number: filter.appointmentsNO,
            startDate: moment(filter.statDate).startOf('day').utc(),
            endDate: moment(filter.endDate).endOf('day').utc(),
            isDeleted: false,
            page: page,
            count: PER_PAGE
        }
        if (filter.statDate.length === 0) {
            delete data.startDate
        }
        if (filter.endDate.length === 0) {
            delete data.endDate
        }
        axios.post(appointmentList(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setAppointmentFilterData(resp.data)
                setCount(resp.data.totalCount);
                setSpinner(false)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                setAppointmentFilterData([])
                setSpinner(false)
                if (page > 1) {
                    setPage(page - 1)
                }
            }
        }).catch(() => {
            toast.error(commonMessage.networkError)
            setSpinner(false)
        })
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilter((preProps) => ({
            ...preProps,
            [name]: value
        }))
    }
    return {
        method: {
            setAppointmentFilterData,
            setClientList,
            setTeamList,
            setFilter,
            setPage,
            setCount,
            navigate,
            setSpinner,
            handleChange,
            appointmentLists
        },
        data: {
            clientList,
            teamList,
            filter,
            page,
            count,
            spinner,
            PER_PAGE,
            appointmentFilterData,
        }

    }
}

export default UseAppointment